<template>
  <transition name="fade">
    <div v-if="store.visible" class="pdf-loading">
      <div class="pdf-spinner"></div>

      <div class="pdf-text">{{ store.text }}</div>

      <div class="progress-container">
        <div class="progress-bar" :style="{ width: store.progress + '%' }"></div>
        <div class="progress-value">{{ Math.floor(store.progress) }}%</div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { usePdfLoading } from '@/stores/usePdfLoading'
const store = usePdfLoading()
</script>

<style scoped>
.pdf-loading {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  color: #fff;
  z-index: 999999;
  font-family: 'Segoe UI', 'Arial', sans-serif;
}

.pdf-spinner {
  width: 80px;
  height: 80px;
  border: 8px solid rgba(255, 255, 255, 0.25);
  border-top-color: #00d8ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.pdf-text {
  margin-top: 20px;
  font-size: 18px;
  letter-spacing: 1px;
  text-shadow: 0 0 10px #00d8ff;
  animation: glow 1.5s ease-in-out infinite alternate;
}

.progress-container {
  position: relative;
  width: 240px;
  height: 12px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  margin-top: 24px;
  overflow: hidden;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #00d8ff, #00ffff, #00d8ff);
  background-size: 200% 100%;
  animation: move 1.5s linear infinite;
  border-radius: 10px;
  transition: width 0.3s ease;
}

.progress-value {
  margin-top: 8px;
  font-size: 14px;
  text-shadow: 0 0 8px #00ffff;
  font-weight: 500;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes glow {
  from {
    opacity: 0.6;
  }
  to {
    opacity: 1;
    text-shadow: 0 0 20px #00ffff;
  }
}

@keyframes move {
  0% {
    background-position: 0% 0%;
  }
  100% {
    background-position: 200% 0%;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
